import type { SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { PilotConfSoftwareId, PilotCsId, PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

export const backofficeFindSitePilotsResponseSchema = z
  .object({
    actionToBeTaken: z.enum(["NONE", "UPDATE_OTA", "UPDATE_USB"]),
    confSoftwareId: z.number().transform((s) => s as PilotConfSoftwareId),
    creationDatetime: z.coerce.date(),
    csId: z
      .number()
      .transform((s) => s as PilotCsId)
      .nullable(),
    hwId: z.number().transform((s) => s as PilotHwId),
    lastIpDate: z.coerce.date().nullable(),
    location: z.string().nullable(),
    operator: z.string().nullable(),
    refOperatingStatus: z.number(),
    serialNumber: z.string().transform((s) => s as SerialNumber),
    siteId: z.number().transform((s) => s as SiteId),
    softwareVersion: z.string(),
    updating: z.boolean(),
  })
  .array();

export type BackofficeFindSitePilotsResponse = z.infer<typeof backofficeFindSitePilotsResponseSchema>;
